import React from 'react'

const HelpWoo = () => {
  return (
    <>
      <h2>How to get WooCommerce Consumer Key and secret for PixelOne</h2>
      <h4>Login into your WooCommerce store with Admin Access:</h4>
      <p>
        1) Goto <strong>WooCommerce {'>'} Settings</strong> and open
        <strong>Advanced tab</strong>
      </p>
      <p>
        2) Click on <strong>REST API</strong> tab and press
        <strong>Add Key</strong> Button
      </p>
      <p>
        3) Enter App name as <strong>PixelOne</strong> and select permissions as
        Read & Write
      </p>
      <p>
        4) Press <strong>Generate API Key</strong> buttons
      </p>
      <p>
        5) You api key and password are ready. Enter that information in the
        given form
      </p>
    </>
  )
}

export default HelpWoo
